module.exports = __webpack_public_path__ + "img/Step3m.93b4d2bc.png";